module.exports = __webpack_public_path__ + "static/img/40pw.bfc29f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40pw.jpg
// module id = eBOM
// module chunks = 1